module.exports = __webpack_public_path__ + "img/fig-user-life-cycle-en.975a7041.svg";